import App from 'app/app.js';
import template from './premium-bg-info-label.html';
import './premium-bg-info-label.scss';
import { POPOVER_TEMPLATE_URL, PopoverManager } from '@app/components/core/popover/popover';

class PremiumBgInfoLabelController {
  DEFAULT_POPOVER = {
    getTitle: () =>
      this.getTranslation(
        this.included ? 'PREMIUM_BACKGROUND_INCLUDED_POPOVER_TITLE' : 'PREMIUM_BACKGROUND_POPOVER_TITLE'
      ),
    getDescription: () =>
      this.getTranslation(
        this.included ? 'PREMIUM_BACKGROUND_INCLUDED_POPOVER_DESCRIPTION' : 'PREMIUM_BACKGROUND_POPOVER_DESCRIPTION'
      )
  };

  constructor($filter) {
    this.$filter = $filter;
    this.popovers = new PopoverManager({
      default: this.DEFAULT_POPOVER
    });
  }

  getPremiumBackgroundPopoverTemplate() {
    return POPOVER_TEMPLATE_URL;
  }

  getPremiumBackgroundMobilePopoverText() {
    return this.getTranslation(
      this.included ? 'PREMIUM_BACKGROUND_MOBILE_INCLUDED_POPOVER_TITLE' : 'PREMIUM_BACKGROUND_MOBILE_POPOVER_TITLE'
    );
  }

  getTranslation(key, params) {
    return this.$filter('ltTranslateFilter')(key, params);
  }

  displayIncludedPill() {
    return this.included && this.displayPill;
  }
}
PremiumBgInfoLabelController.$inject = ['$filter', '$templateCache'];

App.component('ltPremiumBgInfoLabel', {
  template,
  bindings: {
    included: '<',
    popoverPlacement: '<',
    displayPill: '<'
  },
  controller: PremiumBgInfoLabelController,
  controllerAs: '$ctrl'
});
